import { render, staticRenderFns } from "./TutorialItem.vue?vue&type=template&id=5f027e82&scoped=true&"
import script from "./TutorialItem.vue?vue&type=script&lang=js&"
export * from "./TutorialItem.vue?vue&type=script&lang=js&"
import style0 from "./TutorialItem.vue?vue&type=style&index=0&id=5f027e82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f027e82",
  null
  
)

export default component.exports